import "./index.css";

import {
  Button,
  Descriptions,
  Divider,
  Input,
  message,
  Modal,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";

function isValidGrade(grade) {
  return grade >= 0 && grade <= 100;
}

// @ts-ignore
const EditMarkPage = ({
  markData,
  showEditMarkModal,
  setShowEditMarkModal,
}) => {
  const [midterm, setMidterm] = useState(+markData.midterm);
  const [endterm, setEndterm] = useState(+markData.endterm);
  const [final, setFinal] = useState(+markData.final);
  const [isLoading, setIsLoading] = useState(false);
  const history = useNavigate();

  const closeModal = () => {
    setShowEditMarkModal(false);
  };

  const submitData = () => {
    setIsLoading(true);
    if (
      !isValidGrade(midterm) ||
      !isValidGrade(endterm) ||
      !isValidGrade(final)
    ) {
      message.error("Enter valid grade!");
      setIsLoading(false);
      return;
    }

    setIsLoading(false);

    history.go(0);
  };

  let modalContent = isLoading ? (
    <div
      style={{ display: "flex", justifyContent: "center", margin: "200px 0px" }}
    >
      <Spin />
    </div>
  ) : (
    <>
      <Title level={2}>Edit mark</Title>

      <Space size={10} direction={"vertical"}>
        <Space size={10}>
          <span>
            <strong>Name: </strong>
            {markData.name}
          </span>

          <span>
            <strong>Surname: </strong>
            {markData.surname}
          </span>
        </Space>
        <Divider />
        <Space size={10}>
          <Space size={10} direction={"vertical"}>
            <strong>Midterm</strong>
            <Input
              type={"number"}
              value={midterm}
              onChange={(e) => {
                setMidterm(+e.target.value);
              }}
              placeholder={"Midterm mark"}
            />
          </Space>
          <Space size={10} direction={"vertical"}>
            <strong>Endterm</strong>

            <Input
              type={"number"}
              value={endterm}
              onChange={(e) => {
                setEndterm(+e.target.value);
              }}
              placeholder={"Endterm mark"}
            />
          </Space>
          <Space size={10} direction={"vertical"}>
            <strong>Final</strong>
            <Input
              type={"number"}
              value={final}
              onChange={(e) => {
                setFinal(+e.target.value);
              }}
              placeholder={"Final mark"}
            />
          </Space>
        </Space>
        <Divider />
        <Title level={3}>
          TOTAL MARK: {midterm * 0.3 + endterm * 0.3 + final * 0.4}
        </Title>
      </Space>
    </>
  );

  return (
    <Modal
      visible={showEditMarkModal}
      onCancel={closeModal}
      onOk={submitData}
      okText={"Change mark"}
      cancelText={"Cancel"}
    >
      {modalContent}
    </Modal>
  );
};

export default EditMarkPage;
